import React from "react";
import { Switch } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Switcher = ({
  enabled,
  onChange,
  label,
  description,
  showLabel = true,
  className = "",
  isDisabled = false,
  size = "default", // "small", "default", "large"
  ...props
}) => {
  const getSizeClasses = () => {
    switch (size) {
      case "small":
        return {
          switch: "h-4 w-7",
          toggle: "h-3 w-3",
          translate: enabled ? "translate-x-3" : "translate-x-0",
        };
      case "large":
        return {
          switch: "h-8 w-14",
          toggle: "h-7 w-7",
          translate: enabled ? "translate-x-6" : "translate-x-0.5",
        };
      default:
        return {
          switch: "h-6 w-11",
          toggle: "h-5 w-5",
          translate: enabled ? "translate-x-5" : "translate-x-0",
        };
    }
  };

  const sizeClasses = getSizeClasses();

  return (
    <div className={className}>
      <Switch.Group as="div" className="flex items-center">
        <Switch
          checked={enabled}
          onChange={onChange}
          disabled={isDisabled}
          className={classNames(
            enabled ? "bg-indigo-600" : "bg-gray-200",
            isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
            "relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
            sizeClasses.switch
          )}
          {...props}
        >
          <span className="sr-only">{label || "Toggle switch"}</span>
          <span
            aria-hidden="true"
            className={classNames(
              sizeClasses.translate,
              "pointer-events-none inline-block rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200",
              sizeClasses.toggle
            )}
          />
        </Switch>
        {showLabel && (label || description) && (
          <Switch.Label as="span" className="ml-3 text-sm">
            {label && (
              <span className="font-medium text-gray-900">{label}</span>
            )}
            {description && (
              <span className="text-gray-500">
                {label && " "}({description})
              </span>
            )}
          </Switch.Label>
        )}
      </Switch.Group>
    </div>
  );
};

export default Switcher; 